import React from 'react';
import { Icon } from '../../../../components/Icon';
import styles from './LanguageItem.module.scss';
import * as Icons from '../../../../components/FlagIcons/FlagIcons';
import cx from 'classnames';

const LanguageItem = ({ name, src, className, iconClassName }) => {
  return (
    <div className={cx(styles.itemContainer, className)}>
      {src ? <Icon src={src} className={cx(styles.languageIcon, iconClassName)} IconsSource={Icons} /> : null}
      <span className={styles.languageName}>{name}</span>
    </div>
  );
};

export default LanguageItem;
